import './App.css';
import AppRouter from './Routes/AppRouter';

function App() {
  return (
    <div className="App">
      <AppRouter/>
    </div>
  );
}

export default App;